import { useCallback } from 'react';
import { useWSMessage } from '../context/WSMessageContext';

export default function useWSMessageSender() {
  const { sendMessage } = useWSMessage();

  const sendTranscription = useCallback((content) =>
    sendMessage({ type: "TRANSCRIPTION", content }), [sendMessage]);

  const sendTurnAction = useCallback((content) =>
    sendMessage({ type: "TURN_ACTION", content }), [sendMessage]);

  return {
    sendTranscription,
    sendTurnAction
  };
}
